<div
  *ngIf="(keyboardActive$ | async) !== true"
  class="bottom-offset"
  [class]="type"
></div>
